import { render, staticRenderFns } from "./OtherFilter.vue?vue&type=template&id=1c936253"
import script from "./OtherFilter.vue?vue&type=script&lang=js"
export * from "./OtherFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports